import { useEffect, useMemo, useState } from "react";
import CSS from "./static/css/flex.module.css";

const Flex = (
    {
        class_name_list,
        children,
        option,
        lines,
    }:{
        class_name_list?: string[];
        children?: React.ReactNode;
        option?: "margin_bottom_zero";
        lines?: "one" | "two" | "three" | "four";
    }
) => {

    const mainClassName = useMemo(() => {
        const m_total_class_list: string[] = [];

        if(class_name_list){
            for(const class_name of class_name_list){
                m_total_class_list.push(class_name);
            }
        }

        m_total_class_list.push(CSS.l_Flex_main);

        if(option){
            m_total_class_list.push(CSS.option);
            m_total_class_list.push(CSS[option]);
        }

        if(lines){
            m_total_class_list.push(CSS.lines);
            m_total_class_list.push(CSS[lines]);
        }

        return m_total_class_list.join(" ");
    }, [class_name_list, option, lines])

    return (
        <div className={mainClassName}>
            {children}
        </div>
    )
}

export default Flex;